@import (reference) '../../../../../constants/spacing.module.less';

.banner {
  display: flex;
  align-items: center;
  gap: @space-4;

  color: var(--default--text-color--18);
  overflow: hidden;
  border-radius: 0;
  border: solid 1px;
  padding: @space-4 @space-8;

  &.is-warning {
    border-color: var(--warning--message--border-color--2);
    background-color: var(--warning--message--background-color--6);
  }

  &.is-error {
    border-color: var(--error--message--border-color--3);
    background-color: var(--error--message--background-color--5);
  }
}

.icon {
  width: 24px;
  height: 24px;

  padding: @space-4;

  &.is-warning {
    color: var(--warning--icon--fill-color--2);
  }

  &.is-error {
    color: var(--error--icon--fill-color--4);
  }
}

.banner-message {
  flex: 1;

  &.is-warning {
    color: var(--warning--message--text-color--4);
  }

  &.is-error {
    color: var(--error--message--text-color--5);
  }
}

.banner-message-expander-button {
  color: var(--primary--link--text-color--5);
  &:hover {
    color: var(--primary--link--text-color--5);
    text-decoration: underline;
  }
}
